import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"
import { Headline } from "@shared"
import { css } from "@jsUtils"
import { URLS } from "@data"
import { PageSection } from "../PageSection"

import Styles from "./event.module.scss"

/**
 * Event Information
 * @param {object} props - React props
 */
const EventHeader = props => {
  const { color, theme, layout, title, titleImage, headline, textColor } = props
  const [ready, setReady] = React.useState(false)

  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready, Styles.spotlightSection)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <div className={css(Styles.wrapper, Styles[`layout_${layout}`], Styles[`color_${color}`])}>
        <div className={Styles.content}>
          <div className={Styles.contentWrapper}>
            <div className={Styles.mainContent}>
              <Link to={URLS.HOMEPAGE}>
                <Img className={Styles.logo} fluid={titleImage?.content?.fluid} alt={title} />
              </Link>
              <Headline size={3} className={Styles.headline} color={textColor}>
                {headline}
              </Headline>
            </div>
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export default EventHeader
